const AIRPORTS = {
  LGW: {
    code: "LGW",
    slug: "gatwick",
    name: "Gatwick Airport",
    fullName: "London Gatwick Airport",
    postcode: "RH6 0NP",
    station: "Gatwick Airport station",
    terminals: "North and South terminals",
    roads: ["M23", "A23", "M25"],
    rail: "Gatwick Airport station has direct services towards London, Brighton and the South Coast.",
    parkingUrl: "https://www.gatwickairport.com/parking/",
    dropoffPath: "/gatwick-dropoff-calculator",
    accent: "#176b50",
  },
  LTN: {
    code: "LTN",
    slug: "luton",
    name: "Luton Airport",
    fullName: "London Luton Airport",
    postcode: "LU2 9LY",
    station: "Luton Airport Parkway",
    terminals: "Main terminal",
    roads: ["M1", "A1081"],
    rail: "Rail journeys normally connect through Luton Airport Parkway and the DART airport transfer.",
    parkingUrl: "https://www.london-luton.co.uk/parking",
    dropoffPath: null,
    accent: "#16756b",
  },
  STN: {
    code: "STN",
    slug: "stansted",
    name: "Stansted Airport",
    fullName: "London Stansted Airport",
    postcode: "CM24 1RW",
    station: "Stansted Airport station",
    terminals: "Main terminal",
    roads: ["M11", "A120"],
    rail: "Stansted Airport station is beneath the terminal, with services towards London and Cambridge.",
    parkingUrl: "https://www.stanstedairport.com/parking/",
    dropoffPath: "/stansted-dropoff-calculator",
    accent: "#2467a9",
  },
  MAN: {
    code: "MAN",
    slug: "manchester-airport",
    name: "Manchester Airport",
    fullName: "Manchester Airport",
    postcode: "M90 1QX",
    station: "Manchester Airport station",
    terminals: "Terminals 1, 2 and 3",
    roads: ["M56", "M60", "A555"],
    rail: "Manchester Airport station connects the terminals with Manchester Piccadilly and regional services.",
    parkingUrl: "https://www.manchesterairport.co.uk/parking/",
    dropoffPath: "/manchester-airport/drop-off-calculator",
    accent: "#6d4aa2",
  },
};

const AIRPORT_PAGES = Object.values(AIRPORTS).map((airport) => ({
  key: airport.slug,
  type: "airport",
  path: `/${airport.slug}`,
  airportCode: airport.code,
  title: `${airport.name} Journey Planner | Live Rail, Road and Flight Checks`,
  description: `Plan your journey to ${airport.fullName}. Compare rail, taxi and self-drive timing with current flight, road, rail and weather checks.`,
  h1: `Plan your journey to ${airport.name}`,
  intro: `Compare rail, taxi and self-drive before leaving for ${airport.fullName}. The planner combines your journey details with the latest prepared airport conditions.`,
  sitemap: { changefreq: "daily", priority: "0.90" },
}));

const CITY_ROUTES = [
  {
    key: "london-to-gatwick",
    path: "/gatwick/london-to-gatwick",
    airportCode: "LGW",
    city: "London",
    originHint: "London postcode",
    typicalDuration: "45–90 minutes by road",
    routeDetail: "M23 and A23 conditions can materially change the recommended departure time. Direct rail options commonly run from Victoria, London Bridge and other central stations.",
  },
  {
    key: "london-to-luton",
    path: "/luton/london-to-luton",
    airportCode: "LTN",
    city: "London",
    originHint: "London postcode",
    typicalDuration: "50–100 minutes by road",
    routeDetail: "M1 traffic and the transfer between Luton Airport Parkway and the terminal should both be included in the plan.",
  },
  {
    key: "london-to-stansted",
    path: "/stansted/london-to-stansted",
    airportCode: "STN",
    city: "London",
    originHint: "London postcode",
    typicalDuration: "50–100 minutes by road",
    routeDetail: "M11 conditions affect road journeys, while rail plans should allow for reaching the chosen London departure station.",
  },
  {
    key: "manchester-to-manchester-airport",
    path: "/manchester-airport/manchester-to-manchester-airport",
    airportCode: "MAN",
    city: "Manchester",
    originHint: "Manchester postcode",
    typicalDuration: "25–60 minutes by road",
    routeDetail: "M56, M60 and city-centre traffic can change road timing. Direct trains commonly operate from Manchester Piccadilly to the airport station.",
  },
].map((route) => ({
  ...route,
  type: "city-airport",
  title: `${route.city} to ${AIRPORTS[route.airportCode].name} Journey Planner`,
  description: `Plan ${route.city} to ${AIRPORTS[route.airportCode].name}. Compare rail, taxi and self-drive duration, route details and live airport conditions.`,
  h1: `${route.city} to ${AIRPORTS[route.airportCode].name}`,
  intro: `Build a flight-timed journey from ${route.city} and compare rail, taxi and self-drive before leaving.`,
  sitemap: { changefreq: "daily", priority: "0.85" },
}));

export const ajpAirports = Object.freeze(AIRPORTS);
export const ajpAirportPages = Object.freeze(AIRPORT_PAGES);
export const ajpCityRoutePages = Object.freeze(CITY_ROUTES);
export const ajpGeneratedPages = Object.freeze([...AIRPORT_PAGES, ...CITY_ROUTES]);

export function getAjpPage(key) {
  return ajpGeneratedPages.find((page) => page.key === key) || null;
}

export function getAjpAirport(code) {
  return ajpAirports[String(code || "").toUpperCase()] || null;
}
